export default __webpack_public_path__ + "static/media/33.232bd679.png";